<script setup>
import { computed, defineProps, ref, watch } from "vue";
import { useStore } from "vuex";
import AnnouncementDetails from "@/components/announcement/announcement-details.vue";

const props = defineProps({
  // External camera identifier from traffic_record.camera_id.
  camera_id: {
    type: [Number, String],
    default: null,
  },
});

const store = useStore();
const collapsed = ref(false);

const announcements = computed(
  () => store.state.announcement.camera_announcements
);

const cameraAnnouncements = computed(() =>
  announcements.value.filter((item) => item.category === "camera")
);

const load = (cameraId) =>
  store.dispatch("announcement/getCameraAnnouncements", cameraId);

watch(
  () => props.camera_id,
  (cameraId) => load(cameraId),
  { immediate: true }
);
</script>

<template>
  <div v-if="announcements.length" class="col-lg-12 col-xl-12 mb-0">
    <div class="card border border-warning">
      <div
        class="card-header bg-warning-subtle d-flex justify-content-between align-items-center py-2"
      >
        <h6 class="mb-0">
          <i class="mdi mdi-bullhorn me-1"></i>
          Announcements
          <b-badge variant="danger" class="ms-1">{{ announcements.length }}</b-badge>
          <span v-if="cameraAnnouncements.length" class="text-muted fw-normal ms-2 small">
            {{ cameraAnnouncements.length }} for camera {{ props.camera_id }}
          </span>
        </h6>
        <button
          type="button"
          class="btn btn-sm btn-link p-0 text-decoration-none"
          @click="collapsed = !collapsed"
        >
          {{ collapsed ? "Show" : "Hide" }}
        </button>
      </div>
      <div v-if="!collapsed" class="card-body py-2">
        <div
          v-for="(announcement, index) in announcements"
          :key="announcement.id"
          :class="index > 0 ? 'border-top pt-2 mt-2' : ''"
        >
          <AnnouncementDetails :announcement="announcement" :compact="true" />
        </div>
      </div>
    </div>
  </div>
</template>
